export class StrMarker {
    startIndex : number;
    length : number;
    markerClass? : string = 'search-highlighted';

    constructor(startIndex : number, length :number, markerClass?: 'search-highlighted' | 'search-highlighted-active' | 'semibold-text'){
        this.startIndex = startIndex;
        this.length = length;
        if(markerClass){
            this.markerClass = markerClass;
        }
    }
}
